<div>
  <div class="modal-header border-0 pt-4 px-4">
    <h5 class="fw-bold mb-0">Create Custom Zone</h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="modal-body p-4">
    <form class="row g-3">
      <div class="col-12">
        <label class="form-label small fw-bold text-secondary">ZONE NAME</label>
        <input type="text" class="form-control" [(ngModel)]="zoneName" name="name">
      </div>

      <div class="col-md-6">
        <label class="form-label small fw-bold text-secondary">POSTCODE FROM</label>
        <input type="text" class="form-control" [(ngModel)]="postal_code_from" name="from">
      </div>
      <div class="col-md-6">
        <label class="form-label small fw-bold text-secondary">POSTCODE TO</label>
        <input type="text" class="form-control" [(ngModel)]="postal_code_to" name="to">
      </div>

      <div class="col-12">
        <label class="form-label small fw-bold text-secondary">STATE</label>
        <ng-select [items]="stateOptions" bindLabel="label" placeholder="Select a state"
          [(ngModel)]="selectedState" name="state" [loading]="isLoadingStateOptions" [clearable]="true"
          class="custom-ng-select"></ng-select>
      </div>
    </form>
  </div>
  <div class="modal-footer border-0 p-4 pt-0">
    <button type="button" class="btn btn-light px-4" (click)="activeModal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary px-4 fw-bold" (click)="saveCustomZone()">Create Zone</button>
  </div>

</div>
